import { Typography } from '@design-system/components/typography/typography';
import * as css from './EmptyState.css';

type EmptyStateProps = {
  title: string;
  description: string;
};

export const EmptyState = ({ title, description }: EmptyStateProps) => {
  return (
    <div className={css.emptyState}>
      <Typography variant="body" size="medium" color="N-100">
        {title}
      </Typography>
      <Typography variant="body" size="small" color="N-60">
        {description}
      </Typography>
    </div>
  );
};
